import React from "react";
import { Styled } from './styled';
import { BlueButton } from "~/components/pages/features/components/blue-button";

const WebHooks = () => {
  return (
    <Styled.Container>
      <Styled.Title>
        API & webhooks
      </Styled.Title>
      <Styled.Wrapper>
        <Styled.Content>
          <Styled.Block>
            <Styled.Line />
            <Styled.BlockContent>
              <Styled.TitleBlock> {">"}_ HTTP API</Styled.TitleBlock>
              <Styled.Text>Управление возможностями АТС с помощью команд</Styled.Text>
              <Styled.Btn>
                <a href={'https://api2.onlinepbx.ru/documentation/static/index.html'}>
                  <BlueButton noArrow text={'Документация'}/>
                </a>
              </Styled.Btn>
            </Styled.BlockContent>
          </Styled.Block>
          <Styled.Block>
            <Styled.Line2 />
            <Styled.BlockContent>
              <Styled.TitleBlock> {">"}_ WebSockets API</Styled.TitleBlock>
              <Styled.Text>Отслеживание событий по звонкам <br/> в реальном времени и управление активными разговорами</Styled.Text>
              <Styled.Btn>
                <a href={'https://onlinepbx.ru:3342/documentation/index.html'}>
                  <BlueButton noArrow text={'Документация'}/>
                </a>
              </Styled.Btn>
            </Styled.BlockContent>
          </Styled.Block>
        </Styled.Content>
        <div>
          <Styled.Block>
            <Styled.Line />
            <Styled.BlockContent>
              <Styled.TitleBlock> {">"}_ HTTP-запросы</Styled.TitleBlock>
              <Styled.Text>Встраивание запросов <br/> в маршрут звонков</Styled.Text>
              <Styled.Btn>
                <a href={'https://onlinepbx.evateam.ru/docs/docs/DOC-000196#nastrojka-vhodyashhih-zvonkov##2C0t0KaAYSQN7A'}>
                  <BlueButton noArrow text={'Документация'}/>
                </a>
              </Styled.Btn>
            </Styled.BlockContent>
          </Styled.Block>
          <Styled.Block>
            <Styled.Line2 />
            <Styled.BlockContent>
              <Styled.TitleBlock> {">"}_ WebHooks</Styled.TitleBlock>
              <Styled.Text>Отправка уведомлений <br/> по событиям АТС на указанный <br/> адрес</Styled.Text>
              <Styled.Btn>
                <a href={'https://onlinepbx.evateam.ru/docs/docs/DOC-000071#veb-huki-online-pbx'}>
                  <BlueButton noArrow text={'Документация'}/>
                </a>
              </Styled.Btn>
            </Styled.BlockContent>
          </Styled.Block>
        </div>
      </Styled.Wrapper>
    </Styled.Container>
  )
}

export default WebHooks
